import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import {
  saveAnalysisItemMutation,
  analysisItemListByFilter,
} from '../../../shared/queries/AnalysisItem';
import { showNotificationAutoDestroy } from '../../../shared/components/ShowNotification';
import GraphQL from '../../../GraphQL';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../../redux/actions/loadingActions';
import ShiftForm from './Form';
import SmartCard from '../../../shared/components/SmartCard';

const AnalysisItemFormHandler = (props) => {
  const { t, dispatch, match, history } = props;
  const [formOn, setFormOn] = useState(false);
  const [dto, setDto] = useState({ id: 0, active: true });

  const backClickHandler = () => {
    history.push('/minime/item-analise');
  };

  const showLoading = () => {
    dispatch(changeLoadingTrue());
  };

  const hideLoading = () => {
    dispatch(changeLoadingFalse());
  };

  const handleSubmit = (values) => {
    showLoading();
    const mutationQuery = saveAnalysisItemMutation(values);
    GraphQL(mutationQuery, {})
      .then(() => {
        backClickHandler();
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-saved')
        );
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-save')
        );
      })
      .finally(() => {
        hideLoading();
      });
  };

  function findById(id) {
    showLoading();
    const filter = {
      filterByStatus: false,
      updaterId: 0,
      active: true,
      id,
      order: 0,
    };
    const query = analysisItemListByFilter(filter);
    GraphQL(query, {})
      .then((res) => {
        if (res.analysisItemListByFilter) {
          setDto({ ...res.analysisItemListByFilter[0] });
        } else {
          showNotificationAutoDestroy(
            'danger',
            t('notifications.error'),
            t('notifications.record-not-found')
          );
          backClickHandler();
        }
      })
      .catch((error) => {
        if (error.response) {
          showNotificationAutoDestroy(
            'danger',
            t('errors.title'),
            t('errors.error-to-loading')
          );
        }
      })
      .finally(() => {
        hideLoading();
      });
  }

  useEffect(() => {
    if (match.params.id && match.params.id > 0) {
      if (dto.id !== parseInt(match.params.id, 0)) {
        findById(match.params.id);
      } else {
        setFormOn(true);
      }
    } else {
      setFormOn(true);
    }
  }, [dto]);

  return (
    <SmartCard title={t('panels.item-analise')}>
      {formOn ? (
        <ShiftForm
          onSubmit={handleSubmit}
          backHandler={backClickHandler}
          dto={dto}
        />
      ) : null}
    </SmartCard>
  );
};

AnalysisItemFormHandler.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.func.isRequired,
  match: PropTypes.func.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(AnalysisItemFormHandler)
);
